<template>
  <div class="agc-card">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.agc-card {
  background: #fff;
  box-sizing: border-box;
  border: 1px solid #cae4fc;
  border-radius: 10px;
  overflow: hidden;
}
</style>
